import { ReadOutlined } from "@ant-design/icons";
import { RiGroupLine, RiStethoscopeLine } from "react-icons/ri";
import { PiMedal } from "react-icons/pi";
export const SubscriptionData = {
  plans: [
    {
      id: 1,
      name: "Standard",
      priceId: "price_1RY7Q01jq00oBex5NBlBcqmK",
      price: 199,
      billing: "monthly",
      description: "Access to general education library for specialists",
      billingLabel : "/month",
      icon: <ReadOutlined />,
      features: [
        "1 User account",
        "1 Specialty library",
        "1 Scheduler Account",
        "General Library Access",
        "No AI Voiceover",
        "Email Support",
      ],
    },
    {
      id: 2,
      name: "Professional",
      price: 299,
      billing: "monthly",
      billingLabel : "/month",
      description: "For practicing physicians and specialists",
      priceId: "price_1RY7R61jq00oBex5jJ2JSEnW",
      mostPopular: true,
      icon: <RiStethoscopeLine />,
      features: [
        "1 Physician Account",
        "Up to 2 Scheduler Accounts",
        "1 Specialty Library",
        "General Education Library",
        "Personalized AI Voiceover",
        "Analytics Dashboard",
        "24x7 Customer Support",
      ],
    },
    {
      id: 3,
      name: "Group",
      price: 249,
      billing: "monthly",
      billingLabel : "/per user",

      description: "For specialized medical groups (5 - 15 users)",
      icon: <RiGroupLine />,
      priceId: "price_1RY7Rt1jq00oBex5R6Hnrql0",
      features: [
        "5 to 15 User",
        "Up to 4 Scheduler Accounts",
        "Up to 2 Specialty Libraries",
        "General Education Library",
        "Personalized AI Voiceover",
        "Analytics Dashboard",
        "Dedicated Account Manager",
        "Training Sessions",
        "Reporting",
        "24x7 Customer Support",
      ],
    },
    {
      id: 4,
      name: "Enterprise",
      price: "",
      billing: "monthly",
      description: "For large medical organizations",
      icon: <PiMedal />,
      features: [
        "Up to 500 User Accounts",
        "Unlimited Scheduler Accounts",
        "Unlimited Specialty Libraries",
        "Unlimited Education",
        "Account Management Team",
        "Custom Content Creations",
        "Advanced Analytics",
        "Advanced Reporting",
        "Multi-Language Support",
        "24x7x365 Customer Support",
      ],
    },
  ],
};
